module.exports = __webpack_public_path__ + "img/web_qqclogo.7c203222.png";